import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Box } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Header from "./Header";
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
}));
const PriceList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Header title="PriceList" />
      <Typography>{t("pages.pricelist.title")}</Typography>
    </Box>
  );
};

export default PriceList;
